/* eslint-disable no-console */
import THDStorageUtils, { COOKIE_STORAGE } from '@thd-olt-global/thd-storage-utils';

export const getCookie = ({ key }) => {
  try {
    const cookieValue = THDStorageUtils.get(COOKIE_STORAGE, { key });
    const parsedCookieValue = cookieValue !== 'undefined' ? JSON.parse(cookieValue) : null;
    return parsedCookieValue;
  } catch (error) {
    console.error(`personalization-utils: Error getting cookie: ${error}`);
    return null;
  }
};

export const saveCookie = ({ key, response, expiration }) => {
  try {
    THDStorageUtils.set(COOKIE_STORAGE, {
      key,
      expiration,
      value: JSON.stringify(response)
    });
  } catch (error) {
    console.error(`personalization-utils: Error saving cookie: ${error}`);
  }
};